import {IPresenter} from "@/rawdogjs/src//interfaces/IPresenter";
import {HomeView} from "./homeView";
import {ParcelDependencyContainer} from "@/rawdogjs/src//core/ParcelDependencyContainer";
import {Router} from "@/rawdogjs/src//router";
import {UserStore} from "../../data/stores/UserStore";
import {ConfettiHelper} from "../../shared/ConfettiHelper";
import {ClipboardHelper} from "../../shared/ClipboardHelper";
import {BearerTokenApi} from "../../services/api/base/BearerTokenApi";
import {AlertService} from "../../services/AlertService";

export class HomePresenter implements IPresenter {

    public _view: HomeView;
    private dependencyContainer: ParcelDependencyContainer;

    private _connectionCode: string;
    private _alertService: AlertService;

    constructor(homeView: HomeView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = homeView;
        this.dependencyContainer = dependencyContainer;
    }

    async initialize() {

        const userStore = this.dependencyContainer.resolve<UserStore>('UserStore');
        this._alertService = this.dependencyContainer.resolve<AlertService>('AlertService');


        this._view.displayName = userStore.getDisplayName();
        this._view.email = userStore.getEmail();
        this._view.handle = `${userStore.getHandle()}\$${userStore.getSatelliteUrl()}`;

        // userStore.displayName$.subscribe((displayName)=>{
        //     this._view.displayName = displayName    
        // })
        //
        // const appRefreshToken = await this.getAppRefreshToken();
        // this._connectionCode = appRefreshToken.connectionCode;
        //
        // this._view.connectionCode = this._connectionCode;
        //
        // this._view.addOnClickHandler('#btn-connect-inbox',
        //     async () => {
        //         await this.connectToInbox();
        //     }
        // );
        //
        // this._view.addOnClickHandler('#btn-copy-to-clipboard',
        //     async () => {
        //         await this.copyToClipboard(this._connectionCode);
        //         //alert('Copied code to clipboard.');
        //     }
        // );

        const confettiHelper = new ConfettiHelper();
        confettiHelper.start(3000)

        this._view.scrollToTop();
    }

    async connectToInbox() {
        alert('NA')
    }

    async copyToClipboard(text: string) {
        this._alertService.alert('Copied code to clipboard!');
        await ClipboardHelper.copyToClipboard(text);
    }


    async getAppRefreshToken() {

        const authenticationApi = this.dependencyContainer.resolve<BearerTokenApi>('BearerTokenApi');
        const userStore = this.dependencyContainer.resolve<UserStore>('UserStore');

        const tenantId = userStore.getTenantId();

        const result = await authenticationApi.post(
            {
                "createRefreshTokenForApp": {}
            },
            tenantId,
            true,
            true
        )

        return {
            refreshToken: result.data.refreshToken,
            tenantId: result.data.tenantId,
            connectionCode: result.data.connectionCode
        };

    }

    inject() {
    }

}

